export default __webpack_public_path__ + "static/media/FeaturesMobileBackground.737906f9.svg";